import { motion } from "framer-motion";
import { STEPS, ASSETS } from "@/lib/content";
import { PhoneFrame } from "@/components/PhoneFrame";

export const HowItWorks = () => {
  return (
    <section id="how-it-works" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <p className="font-heading text-sm font-bold uppercase tracking-widest text-emerald-600">
            How it works
          </p>
          <h2 className="mt-3 font-heading text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
            Three taps. No spreadsheets.
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Pick what matters, give it a budget, then go enjoy it. Bast quietly minds the rest.
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 items-center gap-12 lg:grid-cols-2">
          <div className="space-y-6">
            {STEPS.map((step, i) => (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, x: -24 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.12 }}
                data-testid={`step-${i + 1}`}
                className="flex gap-5 rounded-3xl border border-white/60 bg-white p-6 shadow-xl shadow-black/5"
              >
                <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-emerald-500 font-heading text-xl font-extrabold text-white">
                  {i + 1}
                </div>
                <div>
                  <h3 className="font-heading text-xl font-bold text-gray-900">{step.title}</h3>
                  <p className="mt-1.5 text-gray-600">{step.body}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.94 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="flex justify-center"
          >
            <PhoneFrame src={ASSETS.shots.valueCoins} alt="Pick your three value coins" />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
